import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-password-criterias',
  templateUrl: './password-criterias.component.html',
  styleUrls: ['./password-criterias.component.scss'],
})
export class PasswordCriteriasComponent {
  @Input() passwordFormControl!: AbstractControl<any, any> | null;

  errors = [
    { label: 'hasEightDigits', content: '8 caracteres' },
    { label: 'hasUpperCase', content: '1 letra maiúscula' },
    { label: 'hasSmallCase', content: '1 letra minúscula' },
    { label: 'hasSpecialChar', content: '1 caractere especial' },
    { label: 'hasNumeric', content: '1 número' },
  ];

  public hasError = (error: string) =>
    !this.passwordFormControl?.errors ||
    !!this.passwordFormControl?.errors?.[error];

  public validator = (error: string) =>
    this.hasError(error) ? 'text-success' : 'plain-text';
}
